import { defineMessages } from 'react-intl';

export const orderAgainRailAllOrdersCTAMessages = defineMessages({
  buttonLabel: {
    defaultMessage: 'View all orders',
    description: 'Orders rail | View all orders CTA | Label',
  },
});
